import React, { useState, useRef, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { loadCart, removeFromCart } from '../../store/actions/cartActions'
import { logout } from '../../store/actions/authActions'
import MobileMenuLanding from './MobileMenuLanding'

const HeaderLanding = (props) => {
    const [menuActive, setMenuState] = useState(false);
    const [cartActive, setcartState] = useState(false);
    const [userDropdownOpen, setUserDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isAuthenticated, user } = useSelector(state => state.auth);
    const { items: carts, loading } = useSelector(state => state.cartAPI);
    const total = (carts || []).reduce((sum, item) => {
        const price = parseFloat(item.product?.price || item.price_snapshot || 0);
        return sum + price * item.quantity;
    }, 0);

    const ClickHandler = () => window.scrollTo(10, 0);

    const totalItems = carts && carts.length > 0
        ? carts.reduce((sum, item) => sum + item.quantity, 0)
        : 0;

    useEffect(() => {
        dispatch(loadCart());
    }, [dispatch]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setUserDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleLogout = async () => {
        setUserDropdownOpen(false);
        await dispatch(logout());
        navigate('/');
    };

    const handleRemoveItem = async (itemId) => {
        try {
            await dispatch(removeFromCart(itemId));
            toast.success('Prodotto rimosso dal carrello');
        } catch (error) {
            toast.error('Errore durante la rimozione del prodotto');
        }
    };

    return (
        <header id="header">
            <div className={"" + props.hclass}>
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                                <MobileMenuLanding />
                            </div>
                            <div className="col-lg-2 col-md-6 col-6">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/"><img src={props.Logo} alt="logo" style={{maxWidth: '260px', width: '100%'}} /></Link>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-1 col-1">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="#">Il mondo Kleeo</Link>
                                            <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/kleeo/la-rivoluzione-pulita">Scheda tecnica</Link></li>
                                                <li><a href="#come-funziona">Come funziona</a></li>
                                                <li><a href="#sicurezza">Sicurezza</a></li>
                                                <li><a href="#salute-app">Salute e App</a></li>
                                                <li><a href="#prezzi">Offerta Lancio</a></li>
                                            </ul>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/shop">Shop</Link>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/contact">Contatti</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-2 col-2">
                                <div className="header-right">
                                    <div className="mini-cart">
                                        <button className="cart-toggle-btn" onClick={() => setcartState(!cartActive)}>
                                            <i className="fi flaticon-shopping-cart"></i>
                                            <span className="cart-count">{totalItems}</span>
                                        </button>
                                        <div className={`mini-cart-content ${cartActive ? "mini-cart-content-toggle" : ""}`}>
                                            <button className="mini-cart-close" onClick={() => setcartState(!cartActive)}><i className="ti-close"></i></button>
                                            <div className="mini-cart-items">
                                                {loading ? (
                                                    <div className="text-center py-3">
                                                        <div className="spinner-border spinner-border-sm" role="status">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                    </div>
                                                ) : carts && carts.length > 0 ? (
                                                    carts.map((item) => (
                                                        <div className="mini-cart-item clearfix" key={item.id}>
                                                            <div className="mini-cart-item-image">
                                                                <span>
                                                                    <img
                                                                        src={item.product?.image || '/images/placeholder.jpg'}
                                                                        alt={item.product?.name || 'Product'}
                                                                    />
                                                                </span>
                                                            </div>
                                                            <div className="mini-cart-item-des">
                                                                <p>{item.product?.name || 'Prodotto'}</p>
                                                                <span className="mini-cart-item-price">
                                                                    €{Number(item.product?.price || item.price_snapshot || 0).toFixed(2)} x {item.quantity}
                                                                </span>
                                                                <span className="mini-cart-item-quantity">
                                                                    <button
                                                                        onClick={() => handleRemoveItem(item.id)}
                                                                        className="btn btn-sm btn-danger"
                                                                        disabled={loading}
                                                                    >
                                                                        <i className="ti-close"></i>
                                                                    </button>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="text-center py-3">
                                                        <p>Il carrello è vuoto</p>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="mini-cart-action clearfix">
                                                <span className="mini-checkout-price">Subtotal: <span>€{(total || 0).toFixed(2)}</span></span>
                                                <div className="mini-btn">
                                                    <Link to="/checkout" className="view-cart-btn s1">Checkout</Link>
                                                    <Link to="/cart" className="view-cart-btn">Carrello</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="close-form">
                                        {isAuthenticated ? (
                                            <div className="position-relative" ref={dropdownRef}>
                                                <button
                                                    className="theme-btn"
                                                    onClick={() => setUserDropdownOpen(!userDropdownOpen)}
                                                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                                                >
                                                    <i className="ti-user"></i>
                                                    <span>{user?.name?.split(' ')[0] || 'Account'}</span>
                                                    <i className={`ti-angle-${userDropdownOpen ? 'up' : 'down'}`} style={{ fontSize: '10px' }}></i>
                                                </button>
                                                {userDropdownOpen && (
                                                    <ul className="user-sub-menu">
                                                        <li><Link to="/account" onClick={() => setUserDropdownOpen(false)}>Il mio account</Link></li>
                                                        <li><Link to="/orders" onClick={() => setUserDropdownOpen(false)}>I miei ordini</Link></li>
                                                        <li><button onClick={handleLogout}>Esci</button></li>
                                                    </ul>
                                                )}
                                            </div>
                                        ) : (
                                            <Link onClick={ClickHandler} className="theme-btn" to="/login">
                                                <i className="ti-user me-1"></i> Accedi
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}

export default HeaderLanding;
